var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("card", { attrs: { borderColor: "gray-40" } }, [
    _c(
      "div",
      { staticClass: "flex-row ai-center" },
      [
        _vm.provider === "gmail"
          ? _c("SaasIcon", {
              attrs: { width: "32", height: "26", icon: "svgGmail" }
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.isGoogleProvider
          ? _c("SaasIcon", {
              attrs: { width: "32", height: "26", icon: "svgGoogle" }
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.isMicrosoftProvider
          ? _c("SaasIcon", {
              attrs: { width: "32", height: "26", icon: "svgOffice365" }
            })
          : _vm._e(),
        _vm._v(" "),
        _c("span", { staticClass: "ml-2 semibold" }, [
          _vm._v(_vm._s(_vm.user))
        ]),
        _vm._v(" "),
        _c("CompassLink", {
          staticClass: "flex-item-right",
          attrs: { label: _vm.ctaLabel, type: "primary" },
          on: {
            click: function($event) {
              return _vm.$emit("callback")
            }
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }